import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import './index.css';

// =============================================================================
// GEAR2GO MEMORIAL PAGE - December 2025
// =============================================================================
// The code below has been preserved as a memorial to the Gear2Go experiment.
// A peer-to-peer rental platform built with love by friends transitioning
// from military service and coding bootcamps into the tech world.
//
// Tested in: Stanford University, Nashville, and the Bay Area (2020-2022)
//
// Co-Founders: Steven Lee, Gavin McGarry
// Developers: Jeremy A. Mattingly, Matthew Blagg
// =============================================================================

import MemorialPage from './components/MemorialPage/MemorialPage';

const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container);

// Render the Memorial Page
root.render(<MemorialPage />);

// =============================================================================
// ORIGINAL GEAR2GO APPLICATION CODE (Preserved for posterity)
// =============================================================================
//
// import ReactDOM from 'react-dom';
// import Gear2GoApp from './Gear2GoApp';
// import * as serviceWorker from './serviceWorker';
// import 'antd/dist/antd.css';
// import './Main.css';
// import { BrowserRouter as Router } from 'react-router-dom';
// import { ThemeProvider } from '@mui/material';
// import { theme } from './theme';
// import 'path-browserify';
//
// const container = document.getElementById('root');
//
// // Create a root.
// const root = ReactDOMClient.createRoot(container);
//
// // Initial render: Render an element to the root.
// root.render(
//   <Router>
//     <ThemeProvider theme={theme}>
//       <Gear2GoApp />
//     </ThemeProvider>
//   </Router>
// );
//
// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
//
// =============================================================================
